module.exports = __webpack_public_path__ + "static/media/frosty-head.01877298.svg";